"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CadetPromotionRequirementsMap = void 0;
exports.CadetPromotionRequirementsMap = [
    {
        CadetAchvID: 0,
        AchvName: 'Cadet Basic',
        Rank: 'C/AB',
        Grade: 'C/AB',
        AchvNumber: 'CadetBasic',
        Oath: false,
        Leadership: 'None',
        Mentor: false,
        SDAService: false,
        SDAWriting: false,
        SDAPresentation: false,
        Drill: 'None',
        DrillItemsPass: 0,
        DrillItemsTotal: 0,
        Aerospace: 'None',
        CharDev: false,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'None',
        LeadTestWebLink: 'None',
        AeroTestWebLink: 'None',
        DrillTestWebLink: 'None',
    },
    {
        CadetAchvID: 1,
        AchvName: 'Gen J F Curry',
        Rank: 'C/Amn',
        Grade: 'C/Amn',
        AchvNumber: 'Achievement 1',
        Oath: true,
        Leadership: '1',
        Mentor: false,
        SDAService: false,
        SDAWriting: false,
        SDAPresentation: false,
        Drill: 'Drill 1',
        DrillItemsPass: 11,
        DrillItemsTotal: 15,
        Aerospace: 'None',
        CharDev: true,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/curry/',
        LeadTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=23',
        AeroTestWebLink: 'None',
        DrillTestWebLink: 'https://drive.google.com/file/d/1Ds7Y8c7SuSMRZ3TNcLiU7CQ7sPXC44vm/view?usp=sharing',
    },
    {
        CadetAchvID: 2,
        AchvName: 'Gen Hap Arnold',
        Rank: 'C/A1C',
        Grade: 'C/A1C',
        AchvNumber: 'Achievement 2',
        Oath: true,
        Leadership: '2',
        Mentor: false,
        SDAService: false,
        SDAWriting: false,
        SDAPresentation: false,
        Drill: 'Drill 2',
        DrillItemsPass: 11,
        DrillItemsTotal: 15,
        Aerospace: 'Aero Dim',
        CharDev: true,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/h-h-hap-arnold-achievement/',
        LeadTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=24',
        AeroTestWebLink: 'https://www.capnhq.gov/CAP.CadetTesting.Web/Modules/Aerospace2ndEdition.aspx',
        DrillTestWebLink: 'https://drive.google.com/file/d/1PWgEh2uzVCapsGsRrcDLKB2kGAn9B72L/view?usp=sharing',
    },
    {
        CadetAchvID: 3,
        AchvName: 'Mary Feik',
        Rank: 'C/SrA',
        Grade: 'C/SrA',
        AchvNumber: 'Achievement 3',
        Oath: true,
        Leadership: '3',
        Mentor: false,
        SDAService: false,
        SDAWriting: false,
        SDAPresentation: false,
        Drill: 'Drill 3',
        DrillItemsPass: 8,
        DrillItemsTotal: 11,
        Aerospace: 'Aero Dim',
        CharDev: true,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/feik/',
        LeadTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=25',
        AeroTestWebLink: 'https://www.capnhq.gov/CAP.CadetTesting.Web/Modules/Aerospace2ndEdition.aspx',
        DrillTestWebLink: 'https://drive.google.com/file/d/1-9rK71EFgPH3UoiDLgUaaBfIKNPHD3FH/view?usp=sharing',
    },
    {
        CadetAchvID: 4,
        AchvName: 'Wright Brothers',
        Rank: 'C/SSgt',
        Grade: 'C/SSgt',
        AchvNumber: 'Wright Brothers',
        Oath: true,
        Leadership: 'Pt 1',
        Mentor: false,
        SDAService: false,
        SDAWriting: false,
        SDAPresentation: false,
        Drill: 'Pt 2',
        DrillItemsPass: 16,
        DrillItemsTotal: 20,
        Aerospace: 'None',
        CharDev: false,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/wright/',
        LeadTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=361',
        AeroTestWebLink: 'None',
        DrillTestWebLink: 'https://drive.google.com/file/d/1Jgbazkmp66UwdHJj6wX_ir_MrL-iZ-dX/view?usp=sharing',
    },
    {
        CadetAchvID: 5,
        AchvName: 'Capt Eddie Rickenbacker',
        Rank: 'C/TSgt',
        Grade: 'C/TSgt',
        AchvNumber: 'Achievement 4',
        Oath: true,
        Leadership: '4',
        Mentor: false,
        SDAService: false,
        SDAWriting: false,
        SDAPresentation: false,
        Drill: 'Drill 4',
        DrillItemsPass: 4,
        DrillItemsTotal: 5,
        Aerospace: 'Aero Dim',
        CharDev: true,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/rickenbacker/',
        LeadTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=26',
        AeroTestWebLink: 'https://www.capnhq.gov/CAP.CadetTesting.Web/Modules/Aerospace2ndEdition.aspx',
        DrillTestWebLink: 'https://drive.google.com/file/d/1zA-Fe5rDbjA2gsHJ4BxZv6R1ooAzv4aF/view?usp=sharing',
    },
    {
        CadetAchvID: 6,
        AchvName: 'Charles Lindbergh',
        Rank: 'C/MSgt',
        Grade: 'C/MSgt',
        AchvNumber: 'Achievement 5',
        Oath: true,
        Leadership: '5',
        Mentor: false,
        SDAService: false,
        SDAWriting: false,
        SDAPresentation: false,
        Drill: 'Drill 5',
        DrillItemsPass: 16,
        DrillItemsTotal: 21,
        Aerospace: 'Aero Dim',
        CharDev: true,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/lindbergh/',
        LeadTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=27',
        AeroTestWebLink: 'https://www.capnhq.gov/CAP.CadetTesting.Web/Modules/Aerospace2ndEdition.aspx',
        DrillTestWebLink: 'https://drive.google.com/file/d/17WSTrodQoqrxsebo05rTOH04G3GsL693/view?usp=sharing',
    },
    {
        CadetAchvID: 7,
        AchvName: 'Gen Jimmy Doolittle',
        Rank: 'C/SMSgt',
        Grade: 'C/SMSgt',
        AchvNumber: 'Achievement 6',
        Oath: true,
        Leadership: '6',
        Mentor: false,
        SDAService: false,
        SDAWriting: false,
        SDAPresentation: false,
        Drill: 'Drill 6',
        DrillItemsPass: 4,
        DrillItemsTotal: 5,
        Aerospace: 'Aero Dim',
        CharDev: true,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/doolittle/',
        LeadTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=28',
        AeroTestWebLink: 'https://www.capnhq.gov/CAP.CadetTesting.Web/Modules/Aerospace2ndEdition.aspx',
        DrillTestWebLink: 'https://drive.google.com/file/d/1n2tDfx7TXT-DUtbKEQVWA7sXo17S35bW/view?usp=sharing',
    },
    {
        CadetAchvID: 8,
        AchvName: 'Dr Robert H Goddard',
        Rank: 'C/CMSgt',
        Grade: 'C/CMSgt',
        AchvNumber: 'Achievement 7',
        Oath: true,
        Leadership: '7',
        Mentor: false,
        SDAService: false,
        SDAWriting: false,
        SDAPresentation: false,
        Drill: 'Drill 7',
        DrillItemsPass: 16,
        DrillItemsTotal: 20,
        Aerospace: 'Aero Dim',
        CharDev: true,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/godda/',
        LeadTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=29',
        AeroTestWebLink: 'https://www.capnhq.gov/CAP.CadetTesting.Web/Modules/Aerospace2ndEdition.aspx',
        DrillTestWebLink: 'https://drive.google.com/file/d/185stIaEYqAJNfiRbehRSw-KHVJ76gAsb/view?usp=sharing',
    },
    {
        CadetAchvID: 9,
        AchvName: 'Neil A Armstrong',
        Rank: 'N/A',
        Grade: 'C/CMSgt',
        AchvNumber: 'Achievement 8',
        Oath: true,
        Leadership: '8',
        Mentor: false,
        SDAService: false,
        SDAWriting: true,
        SDAPresentation: true,
        Drill: 'Drill 8',
        DrillItemsPass: 7,
        DrillItemsTotal: 10,
        Aerospace: 'Aero Dim',
        CharDev: true,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/armstrong/',
        LeadTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=30',
        AeroTestWebLink: 'None',
        DrillTestWebLink: 'https://drive.google.com/file/d/1jxndHnaBjt3Xcu2eUuLKk8LIpNw8aLaZ/view?usp=sharing',
    },
    {
        CadetAchvID: 10,
        AchvName: 'Billy Mitchell',
        Rank: 'C/2dLt',
        Grade: 'C/2dLt',
        AchvNumber: 'Mitchell',
        Oath: true,
        Leadership: 'Milestone',
        Mentor: false,
        SDAService: false,
        SDAWriting: false,
        SDAPresentation: false,
        Drill: 'None',
        DrillItemsPass: 0,
        DrillItemsTotal: 0,
        Aerospace: 'Aero Dim',
        CharDev: false,
        Encampment: true,
        RCLS: false,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/mitchell/',
        LeadTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=359',
        AeroTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=369',
        DrillTestWebLink: 'None',
    },
    {
        CadetAchvID: 11,
        AchvName: 'Flight Commander',
        Rank: 'N/A',
        Grade: 'C/2dLt',
        AchvNumber: 'Achievement 9',
        Oath: true,
        Leadership: '9',
        Mentor: true,
        SDAService: true,
        SDAWriting: true,
        SDAPresentation: true,
        Drill: 'None',
        DrillItemsPass: 0,
        DrillItemsTotal: 0,
        Aerospace: 'TJOF',
        CharDev: true,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/achievement9/',
        LeadTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=31',
        AeroTestWebLink: 'https://www.capnhq.gov/CAP.CadetTesting.Web/Modules/JoFTests.aspx',
        DrillTestWebLink: 'None',
    },
    {
        CadetAchvID: 12,
        AchvName: 'Administrative Officer',
        Rank: 'C/1stLt',
        Grade: 'C/1stLt',
        AchvNumber: 'Achievement 10',
        Oath: true,
        Leadership: '10',
        Mentor: true,
        SDAService: true,
        SDAWriting: true,
        SDAPresentation: true,
        Drill: 'None',
        DrillItemsPass: 0,
        DrillItemsTotal: 0,
        Aerospace: 'TJOF',
        CharDev: true,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/achievement10/',
        LeadTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=32',
        AeroTestWebLink: 'https://www.capnhq.gov/CAP.CadetTesting.Web/Modules/JoFTests.aspx',
        DrillTestWebLink: 'None',
    },
    {
        CadetAchvID: 13,
        AchvName: 'Public Affairs Officer',
        Rank: 'N/A',
        Grade: 'C/1stLt',
        AchvNumber: 'Achievement 11',
        Oath: true,
        Leadership: '11',
        Mentor: true,
        SDAService: true,
        SDAWriting: true,
        SDAPresentation: true,
        Drill: 'None',
        DrillItemsPass: 0,
        DrillItemsTotal: 0,
        Aerospace: 'TJOF',
        CharDev: true,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/achievement11/',
        LeadTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=33',
        AeroTestWebLink: 'https://www.capnhq.gov/CAP.CadetTesting.Web/Modules/JoFTests.aspx',
        DrillTestWebLink: 'None',
    },
    {
        CadetAchvID: 14,
        AchvName: 'Amelia Earhart',
        Rank: 'C/Capt',
        Grade: 'C/Capt',
        AchvNumber: 'Earhart',
        Oath: true,
        Leadership: 'Milestone',
        Mentor: false,
        SDAService: false,
        SDAWriting: false,
        SDAPresentation: false,
        Drill: 'None',
        DrillItemsPass: 0,
        DrillItemsTotal: 0,
        Aerospace: 'Aero Dim',
        CharDev: false,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/earhart/',
        LeadTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=362',
        AeroTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=370',
        DrillTestWebLink: 'None',
    },
    {
        CadetAchvID: 15,
        AchvName: 'Leadership Officer',
        Rank: 'N/A',
        Grade: 'C/Capt',
        AchvNumber: 'Achievement 12',
        Oath: true,
        Leadership: '12',
        Mentor: true,
        SDAService: true,
        SDAWriting: true,
        SDAPresentation: true,
        Drill: 'None',
        DrillItemsPass: 0,
        DrillItemsTotal: 0,
        Aerospace: 'None',
        CharDev: true,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/achievement12/',
        LeadTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=73',
        AeroTestWebLink: 'None',
        DrillTestWebLink: 'None',
    },
    {
        CadetAchvID: 16,
        AchvName: 'Aerospace Education Officer',
        Rank: 'N/A',
        Grade: 'C/Capt',
        AchvNumber: 'Achievement 13',
        Oath: true,
        Leadership: '13',
        Mentor: true,
        SDAService: true,
        SDAWriting: true,
        SDAPresentation: true,
        Drill: 'None',
        DrillItemsPass: 0,
        DrillItemsTotal: 0,
        Aerospace: 'None',
        CharDev: true,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/achievement13/',
        LeadTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=74',
        AeroTestWebLink: 'None',
        DrillTestWebLink: 'None',
    },
    {
        CadetAchvID: 17,
        AchvName: 'Operations Officer',
        Rank: 'C/Maj',
        Grade: 'C/Maj',
        AchvNumber: 'Achievement 14',
        Oath: true,
        Leadership: '14',
        Mentor: true,
        SDAService: true,
        SDAWriting: true,
        SDAPresentation: true,
        Drill: 'None',
        DrillItemsPass: 0,
        DrillItemsTotal: 0,
        Aerospace: 'TJOF',
        CharDev: true,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/achievement14/',
        LeadTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=75',
        AeroTestWebLink: 'https://www.capnhq.gov/CAP.CadetTesting.Web/Modules/JoFTests.aspx',
        DrillTestWebLink: 'None',
    },
    {
        CadetAchvID: 18,
        AchvName: 'Logistics Officer',
        Rank: 'N/A',
        Grade: 'C/Maj',
        AchvNumber: 'Achievement 15',
        Oath: true,
        Leadership: '15',
        Mentor: true,
        SDAService: true,
        SDAWriting: true,
        SDAPresentation: true,
        Drill: 'None',
        DrillItemsPass: 0,
        DrillItemsTotal: 0,
        Aerospace: 'TJOF',
        CharDev: true,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/achievement15/',
        LeadTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=76',
        AeroTestWebLink: 'https://www.capnhq.gov/CAP.CadetTesting.Web/Modules/JoFTests.aspx',
        DrillTestWebLink: 'None',
    },
    {
        CadetAchvID: 19,
        AchvName: 'Cadet Commander',
        Rank: 'N/A',
        Grade: 'C/Maj',
        AchvNumber: 'Achievement 16',
        Oath: true,
        Leadership: '16',
        Mentor: true,
        SDAService: true,
        SDAWriting: true,
        SDAPresentation: true,
        Drill: 'None',
        DrillItemsPass: 0,
        DrillItemsTotal: 0,
        Aerospace: 'TJOF',
        CharDev: true,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/achievement16/',
        LeadTestWebLink: 'https://www.capnhq.gov/CAP.LMS.Web/Quiz/quiz_start.aspx?qid=77',
        AeroTestWebLink: 'https://www.capnhq.gov/CAP.CadetTesting.Web/Modules/JoFTests.aspx',
        DrillTestWebLink: 'None',
    },
    {
        CadetAchvID: 20,
        AchvName: 'Gen Ira C Eaker',
        Rank: 'C/LtCol',
        Grade: 'C/LtCol',
        AchvNumber: 'Eaker',
        Oath: true,
        Leadership: 'None',
        Mentor: false,
        SDAService: false,
        SDAWriting: true,
        SDAPresentation: true,
        Drill: 'None',
        DrillItemsPass: 0,
        DrillItemsTotal: 0,
        Aerospace: 'None',
        CharDev: false,
        Encampment: false,
        RCLS: true,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/eaker/',
        LeadTestWebLink: 'None',
        AeroTestWebLink: 'None',
        DrillTestWebLink: 'None',
    },
    {
        CadetAchvID: 21,
        AchvName: 'Gen Carl A Spaatz',
        Rank: 'C/Col',
        Grade: 'C/Col',
        AchvNumber: 'Spaatz',
        Oath: true,
        Leadership: 'Milestone',
        Mentor: false,
        SDAService: false,
        SDAWriting: true,
        SDAPresentation: false,
        Drill: 'None',
        DrillItemsPass: 0,
        DrillItemsTotal: 0,
        Aerospace: 'Milestone',
        CharDev: false,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'https://www.gocivilairpatrol.com/programs/cadets/stripes-to-diamonds/spaatz-award/',
        LeadTestWebLink: 'None',
        AeroTestWebLink: 'None',
        DrillTestWebLink: 'None',
    },
    {
        CadetAchvID: 22,
        AchvName: 'Gen Carl A Spaatz',
        Rank: 'C/Col',
        Grade: 'C/Col',
        AchvNumber: 'Spaatz',
        Oath: false,
        Leadership: 'None',
        Mentor: false,
        SDAService: false,
        SDAWriting: false,
        SDAPresentation: false,
        Drill: 'None',
        DrillItemsPass: 0,
        DrillItemsTotal: 0,
        Aerospace: 'None',
        CharDev: false,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: '',
        LeadTestWebLink: 'None',
        AeroTestWebLink: 'None',
        DrillTestWebLink: 'None',
    },
    {
        CadetAchvID: 23,
        AchvName: 'Pending',
        Rank: 'Pending',
        Grade: 'Pending',
        AchvNumber: 'Pending',
        Oath: false,
        Leadership: 'None',
        Mentor: false,
        SDAService: false,
        SDAWriting: false,
        SDAPresentation: false,
        Drill: 'None',
        DrillItemsPass: 0,
        DrillItemsTotal: 0,
        Aerospace: 'None',
        CharDev: false,
        Encampment: false,
        RCLS: false,
        ReqsWebLink: 'None',
        LeadTestWebLink: 'None',
        AeroTestWebLink: 'None',
        DrillTestWebLink: 'None',
    },
];
//# sourceMappingURL=promotionRequirements.js.map